import Base from './base'
import urls from 'config/urls'

class Order extends Base {
  find (opts) {
    return this.httpGet({
      url: urls.order.find,
      data: opts
    })
  }

  get (opts) {
    return this.httpGet({
      url: urls.order.get,
      data: opts
    })
  }

  create (opts) {
    return this.httpPost({
      url: urls.order.create,
      data: opts
    })
  }

  update (opts) {
    return this.httpPost({
      url: urls.order.update,
      data: opts
    })
  }

  delete (opts) {
    return this.httpPost({
      url: urls.order.delete,
      data: opts
    })
  }

  cancel (opts) {
    return this.httpPost({
      url: urls.order.cancel,
      data: opts
    })
  }

  createReport (opts) {
    return this.httpPost({
      url: urls.order.createReport,
      data: opts
    })
  }
}

export default new Order



// WEBPACK FOOTER //
// ./src/models/order.js